import { FormGroup } from '@angular/forms';
import { NgForm, ValidationErrors } from '@angular/forms';


class CFormHelper {


    /**
     * Return only the keys with chanded values
     * @param original original object
     * @param modified  object modified
     * @param canAddKeys If false, remove keys not listed on original object
     */
    public getChangedValues<T>(original: T, modified: T, canAddKeys = false, skip: string[] = []): Partial<T> {
        const n = {};
        const newKeys = Object.keys(modified);
        const originalKeys = Object.keys(original);


        if (newKeys && newKeys.length > 0) {
            newKeys.forEach(k => {
                if (!canAddKeys && !originalKeys.includes(k)) { return; }
                if (skip.includes(k)) { return; }
                if (modified[k] !== original[k]) {

                    if (typeof (modified[k]) === 'object' || typeof (original[k]) === 'object') {
                        const oOriginal = original[k];
                        const oModified = modified[k];
                        if (oOriginal && oModified) {
                            const oChanges = this.getChangedValues(oOriginal, oModified, true);
                            if (Object.keys(oChanges).length === 0) { return; }
                        }
                    }
                    n[k] = modified[k];
                }
            });

        }
        return n;
    }

    /**
     * Return the original object with updated values
     * @param original original object
     * @param modified  object modified
     * @param canAddKeys If false, remove keys not listed on original object
     */
    public getUpdated<T>(original: T, modified: Partial<T>, canAddKeys = false): T {
        const KKEYS = Object.keys(original);
        const KMODIFIED = Object.keys(modified);

        const O_NEW: T = { ...original, ...modified };
        if (!canAddKeys) {
            KMODIFIED.forEach(k => {
                if (KKEYS.includes(k)) { return; }
                delete O_NEW[k];
            });
        }

        return O_NEW;
    }

    public getFormValidationErrors(form: FormGroup) {
        const errors = {};
        Object.keys(form.controls).forEach(key => {
            const e = [];
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {

                Object.keys(controlErrors).forEach(keyError => {
                    e.push(`${keyError}: ${controlErrors[keyError]}`);
                });
            }
            if (e.length > 0) {
                errors[key] = e;
            }
        });
        return errors;
    }
}

export const FormHelper = new CFormHelper();

